<div class="lum-modal client-profile-dialog__modal-wrapper">
  <div class="lum-modal__header justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large"
      >{{ isUpdate ? 'Update' : 'Create' }} Supplier Sku</span
    >
  </div>
  <form [formGroup]="form" class="invoice-note-form__wrapper" (submit)="onSubmit()">
    <div class="lum-modal__body">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <div class="lum-label">Supplier</div>
            <lum-ui-autocomplete
              [placeholder]="'Search supplier'"
              [options]="suppliers"
              [debounceTime]="500"
              [loading]="loadingSupplier"
              [displayProperty]="'factory_name'"
              [control]="supplierIdControl"
              (inputChangeEvent)="onSearchSupplierChange($event)"
              (optionSelectedEvent)="onSelectSupplier($event)"
            ></lum-ui-autocomplete>
            <mat-error *ngIf="supplierIdControl && supplierIdControl.invalid">
              <small>
                {{ supplierIdControl | validateField }}
              </small>
            </mat-error>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <div class="lum-label">SKU</div>
            <input type="text" formControlName="sku" class="lum-input" />
            <mat-error *ngIf="skuControl && skuControl.invalid">
              <small>
                {{ skuControl | validateField }}
              </small>
            </mat-error>
          </div>
        </div>
      </div>
    </div>
    <div class="lum-modal__footer">
      <div class="flex ml-auto lum-modal__action">
        <button
          type="button"
          class="lum-button lum-button--secondary mr-2"
          mat-button
          (click)="onClose()"
        >
          Close
        </button>
        <button mat-button type="submit" class="lum-button" [disabled]="loading">
          <div class="flex gap-2 align-items-center">
            <mat-spinner [diameter]="16" *ngIf="loading"></mat-spinner> Save
          </div>
        </button>
      </div>
    </div>
  </form>
</div>
